import { PostCambiarVendedorMasivo } from "../../../reducers/comisionAnualidad";

export interface ReasignacionVendedorStore extends PostCambiarVendedorMasivo {}

export const reasignacionVendedorStore: (
  state
) => ReasignacionVendedorStore = state => {
  const comisionAnualidadState = state.comisionAnualidad;

  return {
    cambiarVendedorMasivoResult:
      comisionAnualidadState.cambiarVendedorMasivoResult,
    postingCambiarVendedorMasivo:
      comisionAnualidadState.postingCambiarVendedorMasivo,
    postingCambiarVendedorMasivoError:
      comisionAnualidadState.postingCambiarVendedorMasivoError
  };
};
